import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const WeighingIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M22,20.2,20.19,7.58a2.34,2.34,0,0,0-.77-1.39A2.1,2.1,0,0,0,18,5.62H15.41l.09-.32q.09-.3.15-.6a2.74,2.74,0,0,0,.06-.59,3.42,3.42,0,0,0-1-2.51,3.39,3.39,0,0,0-2.51-1,3.38,3.38,0,0,0-2.5,1,3.42,3.42,0,0,0-1,2.51,2.74,2.74,0,0,0,.06.59q.06.3.15.6l.1.32H6.4a2.1,2.1,0,0,0-1.47.57,2.35,2.35,0,0,0-.78,1.4L2.36,20.2A2.25,2.25,0,0,0,4.6,22.79H19.75A2.25,2.25,0,0,0,22,20.2ZM11.1,3a1.55,1.55,0,0,1,2.15,0,1.49,1.49,0,0,1,.44,1.08A1.53,1.53,0,0,1,11.1,5.19a1.49,1.49,0,0,1-.44-1.08A1.47,1.47,0,0,1,11.1,3ZM4.31,20.77,6.18,7.64h12L20,20.77Z" />
    </SvgIcon>
  )
}
export default WeighingIcon
